/** Dark mode — same behaviour and storage key as the original: follows the system until the user flips the switch. */
export const THEME_KEY = 'easysaas.theme';

export const currentTheme = (): 'light' | 'dark' => {
  const t = document.documentElement.dataset.theme;
  if (t === 'dark' || t === 'light') return t;
  return typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export function toggleTheme(): 'light' | 'dark' {
  const n = currentTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = n;
  try {
    localStorage.setItem(THEME_KEY, n);
  } catch {
    /* preference only */
  }
  window.dispatchEvent(new CustomEvent('easysaas:theme', { detail: n }));
  return n;
}
